import { render, staticRenderFns } from "./EditInvite.vue?vue&type=template&id=0c2550df&scoped=true&"
import script from "./EditInvite.vue?vue&type=script&lang=js&"
export * from "./EditInvite.vue?vue&type=script&lang=js&"
import style0 from "./EditInvite.vue?vue&type=style&index=0&id=0c2550df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2550df",
  null
  
)

export default component.exports